import { render, staticRenderFns } from "./ManageVeterinaryPatient.vue?vue&type=template&id=be372b62&scoped=true"
import script from "./ManageVeterinaryPatient.vue?vue&type=script&lang=js"
export * from "./ManageVeterinaryPatient.vue?vue&type=script&lang=js"
import style0 from "./ManageVeterinaryPatient.vue?vue&type=style&index=0&id=be372b62&prod&scoped=true&lang=css"
import style1 from "./ManageVeterinaryPatient.vue?vue&type=style&index=1&id=be372b62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be372b62",
  null
  
)

export default component.exports